jQuery(document).on("page.ready", function() {
  $ = jQuery;
  if ($("main.ambassadors").length) {
    $(window).load(function() {
      $(".grid").masonry({
        itemSelector: ".grid-item",
        columnWidth: ".grid-sizer",
        percentPosition: true
      });
    });

    function progressBarBottom() {
      $("div.gf_progressbar_wrapper").each(function(i, e) {
        fielddesc = $("<div>")
          .append($(e).clone())
          .remove()
          .html();

        $(e)
          .siblings("div.gform_body")
          .after(fielddesc);

        $(e).remove();
      });
    }

    progressBarBottom();

    $(document).bind("gform_page_loaded", function() {
      progressBarBottom();
    });
  }
});
